export default "__VITE_ASSET__mwcuXovM__"